module.exports = __webpack_public_path__ + "static/media/Votter-min.4ecb6305.PNG";